<template>
  <div class="main-container">
    <div>
      <Header />
    </div>
    <div :class="['main', { 'main-all': articleRoute }]">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          ><router-link to="/">首页</router-link></el-breadcrumb-item
        >

        <el-breadcrumb-item v-for="item in breadcrumb" :key="item.key">
          <router-link :to="item.link">{{ item.value }}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <app-main />
      <div class="footer">
        <div id="community_name">沁恒微电子社区</div>
      </div>
    </div>
    <div class="floating-box hide-on-mobile" @click="handleClick">
      <el-tooltip
        class="item"
        effect="dark"
        content="意见反馈"
        placement="top-start"
      >
        <i class="el-icon-chat-round"> </i>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { Header, AppMain } from "./components";
import { mapGetters } from "vuex";

export default {
  name: "Layout",
  components: {
    Header,
    AppMain,
  },

  computed: {
    ...mapGetters(["breadcrumb"]),
    articleRoute() {
     // console.log(this.$route.path);
     // console.log(this.$route.path.startsWith("/article"));
      return this.$route.path.startsWith("/article");
    },
  },
  watch: {
    "$store.state.app.breadcrumb"(newData) {
      const length = Object.keys(newData).length;
      let value = "首页";
      if (length > 0) {
        value = newData[length - 1].value;
      }
      document.title = value + " - 沁恒微电子社区";
    },
  },

  methods: {
    setTitle() {},
    handleClick() {
      this.$alert(
        "反馈邮箱：community@wch.cn，无论是关于功能增强的小建议，还是对现有服务的不满，我们都愿意倾听。您的反馈对我们至关重要，帮助我们成长和更好地满足您的需求。",
        "我们非常期待您的宝贵意见！"
      );
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="less" scoped>
.el-breadcrumb {
  margin-top: 20px;
}
.floating-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #2469f6;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;
}
.footer {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: right;
}
/* 移动设备特定样式 */
@media (max-width: 600px) {
  .hide-on-mobile {
    display: none;
  }
}
</style>
